var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCatcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "grayCatcher_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 494",
    fill: "none",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "grayCatcher_svg__b",
    x: -3,
    y: 4.026,
    width: 62,
    height: 49.948,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#grayCatcher_svg__a)",
    "data-name": ".target-image"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#grayCatcher_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 2",
    d: "M35.806 49.717a.426.426 0 01.194-.54l6.942-3.665 8.3-12.668-10.391-7.029a11.209 11.209 0 01-5.208 5.945H20.4a11.218 11.218 0 01-5.216-5.966l-10.42 7.05 8.3 12.668L20 49.176a.426.426 0 01-.327.783l-8.081-2.537L.321 33.454.3 33.43a1.7 1.7 0 01.431-2.371l13.378-9.255.045.076a16.684 16.684 0 01-.139-2.149 13.852 13.852 0 0114-13.7 13.85 13.85 0 0114 13.7 16.663 16.663 0 01-.13 2.076l13.374 9.253a1.7 1.7 0 01.441 2.37l-.018.026-11.275 13.966-8.081 2.537a.426.426 0 01-.52-.242zM19.194 19.459a8.826 8.826 0 108.826-8.829 8.826 8.826 0 00-8.826 8.829zm.994 0a7.831 7.831 0 117.832 7.831 7.832 7.832 0 01-7.832-7.831z",
    fill: "#b3b3b3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCatcher);
export default __webpack_public_path__ + "static/media/grayCatcher.5693cd82852daf61.svg";
export { ForwardRef as ReactComponent };